import { NavLink, Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import PageTranslator from './PageTranslator';

export default function Layout() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F6F4EE' }}>
      <Sidebar />
      <NavLink
        to="/messages"
        aria-label="メッセージを開く"
        title="メッセージ"
        className="fixed right-4 top-3 z-40 flex h-10 w-10 items-center justify-center rounded-full border border-background-200 bg-white text-primary-800 shadow-md transition hover:-translate-y-0.5 hover:shadow-lg md:right-6 md:top-5 md:h-11 md:w-11"
      >
        <i className="ri-chat-3-line text-xl" />
      </NavLink>
      <main className="ml-0 md:ml-[268px] pt-16 md:pt-0 min-h-screen">
        <div className="px-4 md:px-8 py-5 md:py-6">
          <PageTranslator><Outlet /></PageTranslator>
        </div>
      </main>
    </div>
  );
}
